'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parents = [],
    currentHeight = 0;

exports.default = function () {
    var setMaxHeight = function setMaxHeight(height) {
        currentHeight = Math.max(height, currentHeight);
    },
        equalize = function equalize() {
        currentHeight = 0;

        for (var p = parents.length; p--;) {
            var children = parents[p].querySelectorAll('[data-equalize]');

            for (var i = children.length; i--;) {
                children[i].style.height = '';
                setMaxHeight(children[i].offsetHeight);
            }

            for (var _i = children.length; _i--;) {
                children[_i].style.height = currentHeight + 'px';
            }
        }
    },
        getParents = function getParents() {
        parents = document.querySelectorAll('[data-equalizer-container]');
    };

    getParents();
    window.addEventListener('resize', equalize);

    // initial state
    equalize();
};


//////////////////
// WEBPACK FOOTER
// ./client/equalizer.js
// module id = 187
// module chunks = 0